import React from 'react';

const LabeledInput = ({ iw = 80, w = 0, step, min, placeholder, label, type, value, boxstyle = {}, onChange, def, disabled, style = {}, prefix = "", labelstyle = {}, inputstyle = {} }) => {

    if (typeof def === "undefined") def = "";
    if (typeof value === "undefined") value = def;

    if (type === "checkbox") return <div style={{ display: "flex", alignItems: "center" }}>
        <input type={type} checked={!!value} onChange={e => onChange(e.target.checked)} />
        <label disabled={disabled} style={{ marginLeft: 4 }}>{label}</label>
    </div>;

    if (type === "number") return <div>
        {label && <label style={{ width: w ? w : "auto", maxWidth: 140, minWidth: 50, display: "inline-block" }}>{label}</label>}
        <i style={{ fontSize: 12, marginRight: 4 }}>{prefix}</i>
        <input step={step || .01} min={min || 0} style={{ maxWidth: 70, textAlign: "right", paddingLeft: 4, border: "1px solid #ccc", borderRadius: 4, width: iw, }} disabled={disabled} type={type} value={typeof value === "number" ? value.toFixed(2) : value} onChange={e => onChange(e.target.value)} />
    </div>;

    if (type === "datetime-local") return <div>
        <label style={{ width: w ? w : "auto", maxWidth: 140, minWidth: 50, display: "inline-block" }}>{label}</label>
        <input style={{ paddingLeft: 4, border: "1px solid #ccc", borderRadius: 4, width: iw, }} disabled={disabled} type={type} value={value} onChange={e => onChange(e.target.value)} />
    </div>;

    if (type === "date") return <i style={{ fontStyle: "initial", ...boxstyle }}>
        <label style={{ width: w ? w : "auto", display: "inline-block", ...labelstyle }}>{label}</label>
        <input style={{ paddingLeft: 4, border: "1px solid #ccc", borderRadius: 4, width: iw, verticalAlign: "middle", ...inputstyle }} disabled={disabled} type={type} value={value} onChange={e => onChange(e.target.value)} />
    </i>;

    if (type === "time") return <i style={{ fontStyle: "initial" }}>
        <label style={{ width: "auto", paddingRight: 10, display: "inline-block", ...labelstyle }}>{label}</label>
        <input style={{ paddingLeft: 4, border: "1px solid #ccc", borderRadius: 4, minWidth: 100, width: iw, verticalAlign: "middle", ...inputstyle }} disabled={disabled} type={type} value={value} onChange={e => onChange(e.target.value)} />
    </i>;

    if (type === "textarea") return <div>
        <textarea placeholder={placeholder} style={{ border: "1px solid #ccc", borderRadius: 4, padding: 10, width: 280, minHeight: 40, ...style }} disabled={disabled} value={value} onChange={e => onChange(e.target.value)} />
    </div>;

    if (type === "select" && def.length > 0) return <div style={{ fontStyle: "initial", ...boxstyle }}>
        <label style={{ width: w ? w : "auto", maxWidth: 140, minWidth: 50, display: "inline-block", ...labelstyle }}>{label}</label>
        <select style={{ fontSize: 14, paddingLeft: 4, border: "1px solid #ccc", borderRadius: 4, width: iw , ...inputstyle}} disabled={disabled} value={value} onChange={e => onChange(e.target.value)}>
            <option value="">Select</option>
            {def.map((item, i) => <option key={i} value={item}>{item}</option>)}
        </select>
    </div>;

    if (type === "phone") return <div>
        <label style={{ width: w ? w : "auto", maxWidth: 140, minWidth: 50, display: "inline-block" }}>{label}</label>
        <input style={{ paddingLeft: 4, border: "1px solid #ccc", borderRadius: 4, width: iw }} disabled={disabled} type={type} value={value} onChange={e => onChange("+1" + e.target.value.replace('+1', '').replace(/\D/g, ''))} placeholder={placeholder || "+1 (555) 555-5555"} />
    </div>;

    return <div>
        <label style={{ width: w ? w : "auto", maxWidth: 140, minWidth: 50, display: "inline-block" }}>{label}</label>
        <input style={{ paddingLeft: 4, border: "1px solid #ccc", borderRadius: 4, width: iw }} disabled={disabled} type={type} value={value} onChange={e => onChange(e.target.value)} />
    </div>;

}
export default LabeledInput;